/**
 * Create a WeakMap instance factory
 */
export function createInstanceFactory(instanceFactory) {
    const instanceMap = new WeakMap();
    function factory(config) {
        let instance = instanceMap.get(config);
        if (instance)
            return instance;
        instance = instanceFactory(config);
        instanceMap.set(config, instance);
        if (process.env.NODE_ENV === 'development') {
            console.debug('createInstanceFactory', config, instance);
        }
        return instance;
    }
    factory.map = instanceMap;
    return factory;
}
//# sourceMappingURL=createInstanceFactory.js.map